<template>
    <div class="d-flex flex-fill mt-2 mt-md-0">
        <button v-if="agotadas" class="button large-button red-content" disabled>
            {{ $t('partidos.agotadas') }}
        </button>
        <GoToCheckoutButton
            v-else-if="comprar"
            :title="$t('partidos.comprar')"
            :subtitle="$t('partidos.soy_abonado', { abonado: teatro.texto_abonado })"
            :route="ruta"
            :event_id="event.id"
            :sesion_id="event.sesion_id"
            :data-testid="'comprar-evento-abonado-' + event.id"
            tipo_venta="abonados"
        />
    </div>
</template>

<script setup>
    import { computed, getCurrentInstance } from 'vue'

    import GoToCheckoutButton from '@/components/frontend/events/show/GoToCheckoutButton'

    const props = defineProps({
        event: {
            type: Object,
            required: true
        },
        esLfpSga: {
            type: Boolean,
            default: false
        }
    })

    const instance = getCurrentInstance()
    const teatro = computed(() => instance.proxy.$store.getters.getTeatro)
    const hasAbonadoEntries = computed(() => Boolean(props.event.entradas_disponibles_abonos?.length))
    const ruta = computed(() => props.event.varias_sesiones ? 'front.eventos.sesiones' : 'front.eventos.show.abonados')
    const comprar = computed(() => props.esLfpSga || hasAbonadoEntries.value)
    const agotadas = computed(() => {
        if (props.esLfpSga) {
            return props.event.entradas_agotadas_online
        }

        return props.event.entradas_agotadas_online || !hasAbonadoEntries.value
    })
</script>
